export default {
    sms: require('./sms/sms.svg'),
    voice: require('./voice/voice.svg'),
};
